import React, { useState } from 'react';
import '../../entrydoor.css';

const EnergyStarGlass = ({ value, onChange, label = 'Energy Star Glass' }) => {
    const [selectedEnergyStarGlass, setSelectedEnergyStarGlass] = useState(value || "");

    const handleEnergyStarGlassChange = (e) => {
        setSelectedEnergyStarGlass(e.target.value);
        onChange(e.target.value);
        //alert(e.target.value)
        
        const element = document.getElementById("EnergyStarGlassWarning");
            if (element){
                if (e.target.value === 'Yes'){
                    element.style.display = "block";
                }
                else{
                    element.style.display = "None";
                    //alert(e.target.value)
                }
            }
    
    };

    return (
        <div className="a-container">
            <label  style={{ display: 'block' }} htmlFor="EnergyStarGlass">{label}</label>
            <select style={{ display: 'block' }} 
                id="EnergyStarGlass"
                value={selectedEnergyStarGlass}
                onChange={handleEnergyStarGlassChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value="Yes">{selectedEnergyStarGlass === "Yes" ? 'Yes ✔' : 'Yes'}</option>
                <option value="No">{selectedEnergyStarGlass === "No" ? 'No ✔' : 'No'}</option>
            </select>
            <div className = "jamb-warning" id="EnergyStarGlassWarning"  style={{ display: 'none' }}  >
            
            Energy Star Rating for specific orders. Please Note Energy Star is not available for all glass options.
                        
            </div>
        </div>
    );
};

export default EnergyStarGlass;
